import React, { useState } from "react";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import "./AiCallConversation.scss";
import BorderButton from "../../../Reuseable/BorderButton/BorderButton";
import AiConversationModel from "../AiConversationModel/AiConversationModel";

const AiCallConversation = () => {
  const[isModalOpen, setIsModalOpen] = useState(false);

  const dataSource = [
    {
      key: "1",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "15 min",
      summary:
        "Bot offered option to schedule a callback with a human agent. Caller selected 'Later Today' after 1.5 mins of silence.",
      status: 'Chose: "Later today"',
      sentiment: "Disengaged",
    },
    {
      key: "2",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "12 min",
      summary:
        "Bot presented payment options after 90-second silence. Caller stayed on call, but didn’t press any key or speak.",
      status: "Picked: No Response",
      sentiment: "Disengaged",
    },
    {
      key: "3",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "20.4 min",
      summary:
        "Voice response: CRIF impact on non-payment. Borrower said: “Why no money call before salary.”",
      status: "Picked - Negative",
      sentiment: "Irritated",
    },
    {
      key: "4",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "00:56 min",
      summary:
        "Bot offered waiver with an EMI-link option. Customer did not answer.",
      status: "Not Answered",
      sentiment: "Neutral",
    },
    {
      key: "5",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "03:53 min",
      summary:
        "Bot asked: “Would you like to receive help from the recovery center?” Caller pressed 1, confirming basic intent.",
      status: "Replied: ‘Yes’",
      sentiment: "Neutral",
    },
    {
      key: "6",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "12 min",
      summary:
        "Verification done successfully, but bot confirmed account identity. Offer for human escalation was rejected.",
      status: "Picked – Incomplete",
      sentiment: "Neutral",
    },
    {
      key: "7",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "03:28 min",
      summary:
        "Customer verified via algorithm’s 3-part DM replies, including amount and schedule. The customer accepted the waiver.",
      status: "Call Picked (Partial)",
      sentiment: "Irritated",
    },
    {
      key: "8",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "02:32 min",
      summary:
        "Customer refused to engage with SMS/DM signals and/or portal. Customer pickup did not utter any keywords and was silent for 28 seconds.",
      status: "Picked: No Response",
      sentiment: "Unresponsive",
    },
    {
      key: "9",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "04:48 min",
      summary:
        "Final attempt at 100% discount was re-offered and explained the last date as well. The borrower stayed silent and ended the call after 30 seconds.",
      status: "Declined Offer",
      sentiment: "Unresponsive",
    },
    {
      key: "10",
      id: "Apr 23, 2025 – 6:17 PM",
      duration: "11:15 min",
      summary:
        "Voice bot introduced the overdue case, mentioned the amount, and guided the customer to press 1 for payment options or 2 for more time. Caller responded '2' and then disconnected midway.",
      status: "Call Picked (Partial)",
      sentiment: "Neutral",
    },
  ];

  const columns = [
    {
      title: "Date & Time",
      dataIndex: "id",
      key: "id",
      render: (text) => <div style={{ width: "160px" }}>{text}</div>,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (text) => <div style={{ width: "80px" }}>{text}</div>,
    },
    {
      title: "Call Script / Summary",
      dataIndex: "summary",
      key: "summary",
      render: (text) => <div style={{ width: "500px" }}>{text}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <div
          className={`callStatusTag ${
            status.includes("Later")
              ? "later"
              : status.includes("Picked") && status.includes("No Response")
              ? "noResponse"
              : status.includes("Picked") && status.includes("Negative")
              ? "negative"
              : status.includes("Not Answered")
              ? "notAnswered"
              : status.includes("Replied")
              ? "replied"
              : status.includes("Incomplete")
              ? "incomplete"
              : status.includes("Partial")
              ? "partial"
              : status.includes("Declined Offer")
              ? "declined"
              : "-"
          }`}
        >
          {status}
        </div>
      ),
    },
    {
      title: "Sentiment",
      dataIndex: "sentiment",
      key: "sentiment",
      render: (sentiment) => (
        <div
          className={`sentimentTag ${
            sentiment === "Disengaged"
              ? "disengaged"
              : sentiment === "Irritated"
              ? "irritated"
              : sentiment === "Neutral"
              ? "neutral"
              : sentiment === "Unresponsive"
              ? "unresponsive"
              : sentiment === "Avoidant"
              ? "avoidant"
              : sentiment === "Interested"
              ? "interested"
              : sentiment === "Frustrated"
              ? "frustrated"
              : sentiment === "Cooperative"
              ? "cooperative"
              : sentiment === "Uncertain"
              ? "uncertain"
              : sentiment === "Confident"
              ? "confident"
              : sentiment === "Engaged"
              ? "engaged"
              : sentiment === "Unavailable"
              ? "unavailable"
              : sentiment === "Positive"
              ? "positive"
              : sentiment === "Hopeful"
              ? "hopeful"
              : "-"
          }`}
        >
          {sentiment}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (action) => (
        <BorderButton
          text="Call Details"
          onClick={() => setIsModalOpen(true)}
        />
      ),
    },
  ];

  return (
    <div className="aiCallConvMain">
      <ReusableTable
        columns={columns}
        dataSource={dataSource}
        rowKey="key"
        bordered
        pageSize={10}
        CurrentPageNo={1}
        totalItems={18}
      />
      <AiConversationModel
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default AiCallConversation;
